function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.59 22.872v-6.937h2.043l.271-2.39h-2.313l.003-1.197c0-.623.064-.957 1.019-.957h1.277V9h-2.043c-2.454 0-3.318 1.16-3.318 3.11v1.435H13v2.39h1.53v6.937h3.06z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M1 16C1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15z"
}));

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/facebook.e60c56c6.svg";
export { SvgFacebook as ReactComponent };